/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BudgetDrift {
    getFixupPrototypeFunction() { return BudgetDrift.fixupPrototype; }

    static newInstance(model: Partial<BudgetDrift>): BudgetDrift {
        let obj = Object.assign(new BudgetDrift(), model);
        BudgetDrift.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BudgetDrift>): BudgetDrift {
        if (!model) return null;
        return BudgetDrift.newInstance(<BudgetDrift> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BudgetDrift) {
        if (!obj) return;

        models.BudgetDrift.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BudgetDrift): boolean {
        Object.setPrototypeOf(obj, BudgetDrift.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.budget_details) {
            for (let val of this.budget_details) {
                models.BudgetDriftDetail.fixupPrototype(val);
            }
        }
    }

    /**
     * Id of the tenant
     */
    tenant_id: string;

    /**
     * Budget_details
     */
    budget_details: Array<models.BudgetDriftDetail>;

}
